const translations = {
  "en": {
    "Couldn't load": "Couldn't load",
    "Please try again later.": "Please try again later.",
    "Retry": "Retry"
  },
  "zh-tw": {
    "Couldn't load": "無法載入",
    "Please try again later.": "請稍後再試。",
    "Retry": "重試"
  }
};

export default translations;
